<template>
  <div
    class="analyses-hero-search-results"
    data-qa="analyses_hero_search_results"
  >
    <div
      v-if="isLoading"
      class="pa-4"
    >
      <v-skeleton-loader type="list-item-two-line@3" />
    </div>

    <div
      v-else-if="hasResults"
      class="py-1"
    >
      <div class="text-body-2 text-secondary--text px-4 pt-3 pb-1">
        Категории
      </div>
      <a
        v-for="(item, index) in results"
        :key="`${item.object_type}-${index}-${item.name}`"
        :href="item.page_url"
        data-qa="analyses_hero_search_category_item"
        class="analyses-hero-search-results__item d-flex align-center gc-4 px-2 py-3 text-decoration-none"
      >
        <span class="ui-icon-layers ui-icon-fz-medium icon-secondary--text flex-shrink-0" />
        <div class="d-flex flex-column flex-grow-1 min-w-0">
          <div
            class="text-body-1 text--text"
            v-html="highlightTitle(item.name)/* eslint-disable-line vue/no-v-html */"
          />
          <div class="text-body-2 text-secondary--text">
            {{ formatAnalysesCount(item.analyses_count) }}
          </div>
        </div>
        <span class="ui-icon-arrow-right ui-icon-fz-medium icon-secondary--text flex-shrink-0" />
      </a>
    </div>

    <div
      v-else-if="showEmpty"
      class="d-flex flex-column gr-2 text-body-2 text-secondary--text pa-4"
      data-qa="analyses_hero_search_empty"
    >
      <div>
        Ничего не нашли по запросу «{{ trimmedQuery }}»
      </div>
      <div>
        Проверьте название или попробуйте другой запрос.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import highlightSearchText from 'src/core/CoreSelectionList/functions/highlightSearchText'
import { formatLpuCardAnalysesCountText } from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/formatLpuCardTexts'
import type { AnalysesSearchResponse } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesSearch.types'

type Props = {
  query: string
  results: AnalysesSearchResponse
  isLoading?: boolean
  showEmpty?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isLoading: false,
  showEmpty: false,
})

const trimmedQuery = computed(() => props.query.trim())

const hasResults = computed(() => props.results.length > 0)

const formatAnalysesCount = formatLpuCardAnalysesCountText

const highlightTitle = (text: string) => highlightSearchText(text, props.query)
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.analyses-hero-search-results {
  &__item {
    &:hover {
      background-color: $ui-kit-bg-gray-40;
    }
  }
}
</style>
